import React from 'react';

import Alert from './index.js';

const InfoAlert = props => {
  return <Alert type="info" {...props} />;
};

export default InfoAlert;
